var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Screen',_vm._b({},'Screen',{ ..._vm.$attrs, ..._vm.$props },false),[_c('Slide',[_c('Wait',{key:"start",attrs:{"time":0},on:{"done":_vm.onStart}}),_c('p',[_vm._v(_vm._s(_vm.$t('screens.EyetrackingCalibrationScreen.start')))])],1),_c('Slide',[_c('Wait',{key:"calibration",attrs:{"time":0},on:{"done":_vm.runCalibration}}),_c('p',[_vm._v(_vm._s(_vm.$t('screens.EyetrackingCalibrationScreen.instruction')))]),_c('CanvasStage',{staticClass:"point",style:({ left: _vm.x + 'px', top: _vm.y + 'px' }),attrs:{"config":{ width: 26, height: 26 }},on:{"click":_vm.nextPoint}},[_c('CanvasLayer',[_c('CanvasCircle',{attrs:{"config":{
            x: 13,
            y: 13,
            fill: 'red',
            radius: 12,
            stroke: 'black',
            strokeWidth: 1
          }}})],1)],1)],1),_c('Slide',[_c('p',[_vm._v(_vm._s(_vm.$t('screens.EyetrackingCalibrationScreen.error')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }